import classNames from 'classnames'
import React from 'react'
import './tooltip.scss'

export interface TooltipProps {
    text?: string
    content?: React.ReactNode
    position?: 'top' | 'bottom'
    arrowPosition?: 'left' | 'middle' | 'right'
}

export const Tooltip: React.FC<TooltipProps> = ({ text, content, position = 'top', arrowPosition = 'left' }) => {
    if (!text && !content) return null
    return <div className={classNames('tooltip', position, `arrow-${arrowPosition}`)}>{content ?? text}</div>
}
